/*
 Copyright (c) 2025 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright
 notice, this list of conditions and the following disclaimer in
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

import { setDefaultConfiguration } from "./core/configuration.js";

try {
	setDefaultConfiguration({ baseURI: import.meta.url });
} catch {
	// ignored
}

export * from "./zip-core-reader.js";
export * from "./zip-core-writer.js";
export {
	Reader,
	Writer,
	TextReader,
	TextWriter,
	Data64URIReader,
	Data64URIWriter,
	BlobReader,
	BlobWriter,
	HttpReader,
	HttpRangeReader,
	Uint8ArrayWriter,
	Uint8ArrayReader,
	SplitDataReader,
	SplitDataWriter,
	ERR_HTTP_RANGE,
	ERR_HTTP_RESOURCE_CHANGED,
	ERR_ITERATOR_COMPLETED_TOO_SOON,
	ERR_WRITER_NOT_INITIALIZED
} from "./core/io.js";
export {
	getMimeType
} from "./core/util/default-mime-type.js";
export {
	configure,
	resetConfiguration
} from "./core/configuration.js";
export {
	registerCodec,
	unregisterCodec,
	ERR_INVALID_CODEC_DEFINITION,
	ERR_RESERVED_COMPRESSION_METHOD,
	ERR_INVALID_CODEC_MODULE
} from "./core/codec-registry.js";
export {
	createOPFSTempStream
} from "./core/util/opfs-temp-stream.js";
export {
	createBlobTempStream
} from "./core/util/blob-temp-stream.js";
export {
	createSyncAccessHandleTempStream,
	ERR_UNSUPPORTED_CONTEXT
} from "./core/util/sync-access-handle-temp-stream.js";